import slice, { selectors } from './store-front-auth.slice';
import * as thunkActions from './store-front-auth.thunk';

export const storeFrontAuthActions = {
  ...slice.actions
};

export const storeFrontAuthMiddlewares = {
  ...thunkActions
};

export const storeFrontAuthReducer = slice.reducer;
export const storeFrontAuthSelectors = selectors;
